import { FC } from 'react'
import { Box, Grid } from '@mui/material'
import { Task } from 'src/api'
import { useImagesViewer, useQueryParams } from 'src/hooks/ui'
import { useTaskListRequest } from 'src/hooks/api'
import { ImagesListItem } from 'src/contexts'
import { ImagesViewerStateProvider } from 'src/components/providers'
import { defaultRowsValuePerPage } from 'src/config'
import { TaskFilters, TaskList } from '../task'
import { TaskColumnsDataGrid } from '../task/tableColumns'

type Props = {
  tasks: Task[]
  count: number
  queryParams: Record<string, string>
  setQueryParams: (params: Record<string, string>, paramsToRemove?: string[]) => void
}

const defaultPerPage = 25
const defaultPage = 1
const defaultRowsPerPageOptions = defaultRowsValuePerPage
const initialQueryParams = {
  page: `${defaultPage}`,
  rowsPerPage: `${defaultPerPage}`,
}
const columns = ({
  openGallery,
}: {
  openGallery: (imgs: ImagesListItem[]) => void
}) => [
  TaskColumnsDataGrid.NameWithIcon,
  TaskColumnsDataGrid.Description,
  TaskColumnsDataGrid.Status,
  TaskColumnsDataGrid.Author,
  TaskColumnsDataGrid.Assignee,
  TaskColumnsDataGrid.ProjectSection,
  TaskColumnsDataGrid.CreatedAt,
  TaskColumnsDataGrid.Photo(openGallery)
]

const ProjectTasksContent: FC<Props> = ({
  tasks,
  count,
  queryParams,
  setQueryParams
}) => {
  const { openGallery } = useImagesViewer()
  return (
    <Grid container>
      <Grid item>
        <TaskFilters />
      </Grid>
      <Grid item width="100%">
        <Box height="500px">
          <TaskList
            data={tasks}
            count={count}
            columns={columns({ openGallery })}
            defaultRowsPerPageOptions={defaultRowsPerPageOptions}
            queryParams={queryParams}
            setQueryParams={setQueryParams}
          />
        </Box>
      </Grid>
    </Grid>
  )
}

export const ProjectTasks: FC<{ projectId: number }> = ({
  projectId,
}) => {
  const [queryParams, setQueryParams] = useQueryParams(initialQueryParams)
  const projectTasksRequest = useTaskListRequest({
    params: { ...queryParams, projectId },
  })

  return (
    <ImagesViewerStateProvider>
      <ProjectTasksContent
        tasks={projectTasksRequest.data?.rows || []}
        count={projectTasksRequest.data?.count || 0}
        queryParams={queryParams}
        setQueryParams={setQueryParams}
      />
    </ImagesViewerStateProvider>
  )
}
